/**
 * 应用
 */
export const CACHE_COOKIES = 'CACHE_COOKIES'
export const GET_APP_DETAIL = 'GET_APP_DETAIL'
export const SET_APP_DETAIL = 'SET_APP_DETAIL'

export const GET_APP_SETTING = 'GET_APP_SETTING'
export const SET_APP_SETTING = 'SET_APP_SETTING'    // 保存并发布
export const SAVE_APP_SETTING = 'SAVE_APP_SETTING'  // 保存

/**
 * 组件
 */
export const GET_COMPONENTS = 'GET_COMPONENTS'
export const SET_CLASSIFY_COMPONENTS = 'SET_CLASSIFY_COMPONENTS'
export const SET_COMPONENTS = 'SET_COMPONENTS'
export const GET_PRESETED_COMPONENT = 'GET_PRESETED_COMPONENT'
export const GET_CUSTOMIZE_COMPONENT = 'GET_CUSTOMIZE_COMPONENT'
export const GET_BUILTIN_COMPONENT = 'GET_BUILTIN_COMPONENT'
export const GET_SPECIAL_COMPONENT = 'GET_SPECIAL_COMPONENT'
export const SET_PRESETED_COMPONENT = 'SET_PRESETED_COMPONENT'
export const SET_CUSTOMIZE_COMPONENT = 'SET_CUSTOMIZE_COMPONENT'
export const SET_SPECIAL_COMPONENT = 'SET_SPECIAL_COMPONENT'
export const SET_BUILTIN_COMPONENT = 'SET_BUILTIN_COMPONENT'
export const SET_FORM_COMPONENT = 'SET_FORM_COMPONENT'

export const REGEST_BIZ_COMPONENTS = 'REGEST_BIZ_COMPONENTS'

export const GET_LOCAL_COMPONENT = 'GET_LOCAL_COMPONENT'
export const SET_LOCAL_COMPONENT = 'SET_LOCAL_COMPONENT'
export const UPDATE_LOCAL_COMPONENT = 'UPDATE_LOCAL_COMPONENT'

/**
 * 页面
 */
export const SET_PAGES = 'SET_PAGES'
export const GET_PAGES = 'GET_PAGES'
export const CREATE_PAGE = 'CREATE_PAGE'
export const CREATE_PAGE_BY_TEMPLATE = 'CREATE_PAGE_BY_TEMPLATE'
export const GET_PAGE_TEMPLATE = 'GET_PAGE_TEMPLATE'
export const COPY_PAGE = 'COPY_PAGE'
export const DELETE_PAGE = 'DELETE_PAGE'
export const UPDATE_PAGE = 'UPDATE_PAGE'
export const MOVE_PAGE = 'MOVE_PAGE'
export const SET_LOGIN = 'SET_LOGIN'
export const UNSET_LOGIN = 'UNSET_LOGIN'
export const SET_HOME = 'SET_HOME'
export const SET_PAGE_STATUS = 'SET_PAGE_STATUS'

export const GET_SYSTEM_PAGES = 'GET_SYSTEM_PAGES'
export const SET_SYSTEM_PAGES = 'SET_SYSTEM_PAGES'

export const CREATE_FOLDER = 'CREATE_FOLDER'
export const DELETE_FOLDER = 'DELETE_FOLDER'
export const COPY_FOLDER = 'COPY_FOLDER'
export const UPDATE_FOLDER = 'UPDATE_FOLDER'

export const ALTER_PAGE = 'ALTER_PAGE'
export const ALTER_PAGE_LOCKER = 'ALTER_PAGE_LOCKER'
export const SET_PAGE_LOCKER_ID = 'SET_PAGE_LOCKER_ID'
export const GET_ASSIGNED_PAGE = 'GET_ASSIGNED_PAGE'
export const GET_NAVIGATIONS = 'GET_NAVIGATIONS'
export const SET_LOCKER_LOADING = 'SET_LOCKER_LOADING'
export const SET_FIRST_LOCKER_LOADED = 'SET_FIRST_LOCKER_LOADED'
export const SET_ASSIGNED_PAGE_LOADING = 'SET_ASSIGNED_PAGE_LOADING'
export const UPDATE_ROOTING_PAGE_EXPRESSION = 'UPDATE_ROOTING_PAGE_EXPRESSION'
export const UPDATE_ROOTING_PAGE_TENANT = 'UPDATE_ROOTING_PAGE_TENANT'
export const UPDATE_PAGE_BY_PAGEID = 'UPDATE_PAGE_BY_PAGEID'
export const UPDATE_PAGE_LOCKER_ID = 'UPDATE_PAGE_LOCKER_ID'

// 元数据
export const SAVE_PAGE_META = 'SAVE_PAGE_META' // 保存

export const SAVE_NAVIGATION_META = 'SAVE_NAVIGATION_META' // 保存

export const UPDATE_PAGE_META = 'UPDATE_PAGE_META'  // 保存并发布
export const UPDATE_PAGE_META_ALL = 'UPDATE_PAGE_META_ALL'  // 全量发布

/**
 * 配置
 */
export const GET_CONF_LIST = 'GET_CONF_LIST'
export const SET_CONF_LIST = 'SET_CONF_LIST'
export const GET_SYSTEM_CONF_LIST = 'GET_SYSTEM_CONF_LIST'
export const SET_SYSTEM_CONF_LIST = 'SET_SYSTEM_CONF_LIST'
export const GET_USER_LIST = 'GET_USER_LIST'
export const SET_USER_LIST = 'SET_USER_LIST'
export const ADD_CONF = 'ADD_CONF'
export const SAVE_CONF = 'SAVE_CONF'        // 保存配置
export const SAVE_CONF_V2 = 'SAVE_CONF_V2'        // 保存配置v2
export const UPDATE_CONF = 'UPDATE_CONF'    // 更新配置
export const UPDATE_CONF_ALL = 'UPDATE_CONF_ALL'    // 全量发布
export const UPDATE_CONF_ALL_V2 = 'UPDATE_CONF_ALL_V2'    // 全量发布v2
export const RESET_CONF = 'RESET_CONF'
export const DELETE_CONF = 'DELETE_CONF'
export const GET_METADATA_STATUS = 'GET_METADATA_STATUS'
export const SET_METADATA_STATUS = 'SET_METADATA_STATUS'
export const GET_BUSINESS_ENV_DETAIL = 'GET_BUSINESS_ENV_DETAIL'
export const SET_BUSINESS_ENV_DETAIL = 'SET_BUSINESS_ENV_DETAIL'

// 集成应用
export const GET_APP_LIST = 'GET_APP_LIST'
export const SET_APP_LIST = 'SET_APP_LIST'

// 小程序
export const MP_API = 'MP_API' // 通过vuex只调用API

export const DESIGNER_REFRESH = 'DESIGNER_REFRESH'

// 获取模版列表
export const GET_TEMPLATE_LIST = 'GET_TEMPLATE_LIST'
export const SET_TEMPLATE_LIST = 'SET_TEMPLATE_LIST'
// 模版上架
export const SET_TEMPLATE_STATUS = 'SET_TEMPLATE_STATUS'
// 模版启用
export const USE_TEMPLATE = 'USE_TEMPLATE'
// 模版截图上传
export const UPDATE_TEMPLATE_COVER = 'UPDATE_TEMPLATE_COVER'

export const GET_GALLERY_IMAGE = 'GET_GALLERY_IMAGE'
export const DELETE_GALLERY_IMAGE = 'DELETE_GALLERY_IMAGE'
export const UPDATE_GALLERY_IMAGE = 'UPDATE_GALLERY_IMAGE'
export const MOVE_GALLERY_IMAGE = 'MOVE_GALLERY_IMAGE'

export const GET_GALLERY_GROUP = 'GET_GALLERY_GROUP'
export const CREATE_GALLERY_GROUP = 'CREATE_GALLERY_GROUP'
export const DELETE_GALLERY_GROUP = 'DELETE_GALLERY_GROUP'
export const UPDATE_GALLERY_GROUP = 'UPDATE_GALLERY_GROUP'
export const MOVE_GALLERY_GROUP = 'MOVE_GALLERY_GROUP'
export const GET_OSS_CONFIG = 'GET_OSS_CONFIG'
export const ADD_GALLERY_IMAGE = 'ADD_GALLERY_IMAGE'

export const GET_ICON_INFO = 'GET_ICON_INFO'
export const SET_ICON_INFO = 'SET_ICON_INFO'

export const URI_ACCESS = 'URI_ACCESS'
export const URI_ACCESSED = 'URI_ACCESSED'
//历史记录相关api
export const GET_HISTORY_LISTS = 'GET_HISTORY_LISTS'  //获取历史记录列表
export const POST_HISTORY_RECOVER = 'POST_HISTORY_RECOVER' //恢复历史记录
export const GET_HISTORY_DETAIL = 'GET_HISTORY_DETAIL'  //获取某个历史详情

// 业务对象
export const GET_OBJECT_LIST = 'GET_OBJECT_LIST'
export const GET_OBJECT_DETAIL = 'GET_OBJECT_DETAIL'

export const GET_EXPRESSION_LIST = 'GET_EXPRESSION_LIST'
export const GET_EXPRESSION = 'GET_EXPRESSION'
export const CREATE_EXPRESSION = 'CREATE_EXPRESSION'
export const DELETE_EXPRESSION = 'DELETE_EXPRESSION'
export const UPDATE_EXPRESSION = 'UPDATE_EXPRESSION'

//扩展代码
export const GET_FUNCTION_LIST = 'GET_FUNCTION_LIST'
export const GET_VALIDATE_FUNCTION_LIST = 'GET_VALIDATE_FUNCTION_LIST'

export const ADD_FUNCTION = 'ADD_FUNCTION'
export const BATCH_ADD_FUNCTION = 'BATCH_ADD_FUNCTION'
export const EDIT_FUNCTION = 'EDIT_FUNCTION'
export const SAVE_FUNCTION = 'SAVE_FUNCTION'
export const DELETE_FUNCTION = 'DELETE_FUNCTION'
export const BATCH_DELETE_FUNCTION = 'BATCH_DELETE_FUNCTION'
export const BUILD_FUNCTION = 'BUILD_FUNCTION'
export const BATCH_BUILD_FUNCTION = 'BATCH_BUILD_FUNCTION'
export const GET_USED_FUNCTION_LIST = 'GET_USED_FUNCTION_LIST'

// data service
export const GET_DATA_OBJECT_LIST = 'GET_DATA_OBJECT_LIST'
export const GET_DATA_SERVICE_LIST = 'GET_DATA_SERVICE_LIST'

// data expression
export const GET_DATA_EXPRESSION_LIST = 'GET_DATA_EXPRESSION_LIST'
export const GET_DATA_EXPRESSION = 'GET_DATA_EXPRESSION'
export const CREATE_DATA_EXPRESSION = 'CREATE_DATA_EXPRESSION'
export const DELETE_DATA_EXPRESSION = 'DELETE_DATA_EXPRESSION'
export const UPDATE_DATA_EXPRESSION = 'UPDATE_DATA_EXPRESSION'
export const UPDATE_PAGE_DATA_EXPRESSION = 'UPDATE_PAGE_DATA_EXPRESSION'

// 发布

export const ADD_VERSION = 'ADD_VERSION'
export const PUBLISH_METADATA = 'PUBLISH_METADATA'
export const GET_WORKSPACE_ENV = 'GET_WORKSPACE_ENV'
export const GET_CATEGORY_VERSION = 'GET_CATEGORY_VERSION'

export const BUILD_APP = 'BUILD_APP'
export const DEPLOYMENT_APP = 'DEPLOYMENT_APP'
export const GET_TOKEN = 'GET_TOKEN'
export const FETCH_META_DATA = 'FETCH_META_DATA'

// 预览

export const SAVE_PREVIEW_TOKEN = 'SAVE_PREVIEW_TOKEN'

export const REFRESH_TOKEN = 'REFRESH_TOKEN'

export const UPDATE_LOADING = 'UPDATE_LOADING'
// 权限
export const GET_VALID_PURVIEW = 'GET_VALID_PURVIEW'
export const SET_VALID_PURVIEW = 'SET_VALID_PURVIEW'

// designer
export const UPDATE_REFRESH_FLAG = 'UPDATE_REFRESH_FLAG'
export const INIT_APP = 'INIT_APP'

export const GET_CHECK_ERROR_LIST = 'GET_CHECK_ERROR_LIST'

export const SAVE_COMPONENT_TEMPLATE = 'SAVE_COMPONENT_TEMPLATE'

export const GET_STAR_MAP_ENV = 'GET_STAR_MAP_ENV'
export const GET_SERVICE_UPDATE = 'GET_SERVICE_UPDATE'
export const SET_TABS_MESSAGE_COUNT = 'SET_TABS_MESSAGE_COUNT'

// sdk 中使用的 type，在设计时不需要对应的 action 或者 mutation
export const GET_DYNAMIC_META = 'GET_DYNAMIC_META'
export const PRUNE_CACHE = 'PRUNE_CACHE'
export const SET_APP_CONTEXT = 'SET_APP_CONTEXT'
export const SET_APP_META = 'SET_APP_META'
export const SET_DYNAMIC_META = 'SET_DYNAMIC_META'
export const SET_RENDER_CACHE = 'SET_RENDER_CACHE'
export const UPDATE_AUTH_STATUS = 'UPDATE_AUTH_STATUS'

// 页面分组
export const CREATE_PAGE_GROUP = 'CREATE_PAGE_GROUP'
export const EDIT_PAGE_GROUP = 'EDIT_PAGE_GROUP'
export const REMOVE_PAGE_GROUP = 'REMOVE_PAGE_GROUP'

export const GET_OBJECT_DETAIL_BY_ID = 'GET_OBJECT_DETAIL_BY_ID'

export const GET_LINKAGE_LIST = 'GET_LINKAGE_LIST'
export const GET_LINKAGE_INFO = 'GET_LINKAGE_INFO'
export const ADD_LINKAGE = 'ADD_LINKAGE'
export const EDIT_LINKAGE_NAME = 'EDIT_LINKAGE_NAME'
export const EDIT_LINKAGE_INFO = 'EDIT_LINKAGE_INFO'
export const DELETE_LINKAGE = 'DELETE_LINKAGE'

// 素材库
export const GET_IMAGE_LIBRARY = 'GET_IMAGE_LIBRARY'
export const GET_IMAGE_LIBRARY_FOLDER = 'GET_IMAGE_LIBRARY_FOLDER'
export const ADD_IMAGE_FOLDER = 'ADD_IMAGE_FOLDER'
export const ADD_IMAGES = 'ADD_IMAGES'
export const DELETE_IMAGE = 'DELETE_IMAGE'
